import React from 'react';
import { Link } from 'react-router-dom';

export default function PageHeaderTitle({
	title = '',
	subTitle = '',
	isMobile = true,
	className = '',
	onClick = () => {}
}) {
	if (isMobile) {
		return (
			<>
				<div className={`page_header_title ${className}`}>
					<Link to="#" onClick={onClick}>
						<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M9 17L1 9L9 1"
								stroke="white"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</Link>

					<h5>{title}</h5>
					<p></p>
				</div>
				{subTitle && <p>{subTitle}</p>}
			</>
		);
	}

	return null;
}
